import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import {
  Row,
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import {
  faCommentDots,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  putAPI_Update_Response,
  postAPI_Create_A_Message,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

function Tag({ setIsAddTagToFalse, elem, dialogUpdate, dialogIndex }) {
  const [postData, setPostData] = useState(elem);
  const [dialogTags, setDialogTags] = useState([]);
  const handleTagChange = (event) => {
    setDialogTags(event);
    console.log(event);
  };

  const handleSave = async () => {
    const data = { ...postData };

    data.tags = dialogTags;

    console.log('data', data);
    dialogUpdate(data, dialogIndex);
    if (setIsAddTagToFalse) {
      setIsAddTagToFalse();
    }
  };

  const handleCancel = () => {
    if (setIsAddTagToFalse) {
      setIsAddTagToFalse();
    }
  };

  const Editing = () => {
    return (
      <Fragment>
        <CardTitle>
          <Row style={{ textAlign: 'left' }}>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.message" />
              </div>
            </Colxx>
            <Colxx xxs="6">
              <div className="float-right">
                <Button
                  color="primary"
                  className="add-button"
                  size="xs"
                  onClick={handleSave}
                >
                  Save
                </Button>
                <b> </b>
                <Button
                  color="secondary"
                  className="add-button"
                  size="xs"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row className="mb-2">
          <Colxx xxs="12">
            <TagsInput
              value={dialogTags}
              onChange={(event) => handleTagChange(event)}
            />
          </Colxx>
        </Row>
      </Fragment>
    );
  };

  return (
    <Card>
      <CardBody>{Editing()}</CardBody>
    </Card>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps)(Tag));
